<template>
    <div class="home-advantages">
        <img :src="imgLeft" alt="Image Left" class="home-advantages__outer-img home-advantages__outer-img--left">
        <img :src="imgRight" alt="Image Right" class="home-advantages__outer-img home-advantages__outer-img--right">
        <div class="home-advantages__title-block"></div>
        <div v-html="title" class="home-advantages__title"></div>
        <div class="home-advantages__list-block">
            <ul>
                <li v-html="entry1"></li>
                <li v-html="entry2"></li>
                <li v-html="entry3"></li>
                <li v-html="entry4"></li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            bemclass: {
                type: String,
                default: ""
            },
            entry1: {
                type: String,
                default: ""
            },
            entry2: {
                type: String,
                default: ""
            },
            entry3: {
                type: String,
                default: ""
            },
            entry4: {
                type: String,
                default: ""
            },
            title: {
                type: String,
                default: ""
            },
            image: {
                type: String,
                default: ""
            }
        },

        data(){
            return{
                imgLeft: "",
                imgRight: ""
            }
        },

        mounted(){
            this.imgLeft = document.querySelector(".home-blog__outer-img--left").getAttribute("src");
            this.imgRight = document.querySelector(".home-blog__outer-img--right").getAttribute("src");
        },
    }
</script>
